<template>
  <custom-callout border-color-hex="#FB7058" class="mb-4" :has-toggle="false">
    <icon-view
      class="mt-2 ml-4 pl-3"
      icon="fas fa-user mb-1"
      icon-background="#fff"
      icon-color="#ff745c"
      icon-size="14px"
      title="Búsqueda de Estudiante"
    />
    <validation-observer ref="reinbursementRef">
      <div class="row mt-3 ml-4">
        <div class="col-md-4 col-sm-12 mt-3 mt-md-0">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              required: 'El número SIE, Registro o Consulta es requerido.',
              startsLikeTapRequestNumber: 'El número de consulta no es válido.',
              studentSie: 'El número de SIE no es válido.',
            }"
            :rules="{
              required: true,
              startsLikeTapRequestNumber: startWithLetters,
              studentSie: !startWithLetters,
            }"
          >
            <custom-input
              v-model="tapRequestNumber"
              :error="errors[0]"
              icon="fa fa-search color-orange"
              label-class="font-14"
              left-icon
              placeholder="Escriba número de sie, número de registro o número de consulta"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-6">
          <action-button
            i="fa fa-search"
            text="Buscar"
            variant="success px-4"
            @click="handlerSearch"
          />
        </div>
        <div class="col-12 mt-4 d-flex justify-content-end">
          <action-button
            v-if="!showRequest"
            i="fas fa-times-circle"
            text="Cerrar"
            variant="outline-danger  m-md-2 px-4"
            @click="onCancel"
          />
        </div>
      </div>
    </validation-observer>
    <div v-if="showRequest">
      <div class="row ml-2 mt-2 mb-3">
        <icon-view
          class="mt-2"
          :has-border="false"
          icon="fas fa-info pb-1"
          icon-background="#ff745c"
          icon-color="#fff"
          icon-size="14px"
          title="Información del Estudiante"
        />
      </div>
      <div
        class="row my-2 ml-2 mr-3 pl-4 pt-3 pb-4 bg-white border-radius--light request-reinbursement-custom-callout"
      >
        <div class="col-md-2 col-sm-12 mt-3 mt-md-0">
          <span class="color-gray-6 d-block font-14">
            Nombre del Estudiante:
          </span>
          <span class="font-16 color-black">
            {{ model.studentName }}
          </span>
        </div>
        <div class="col-md-2 col-sm-12 mt-3 mt-md-0">
          <span class="color-gray-6 d-block font-14">
            SIE:
          </span>
          <span class="font-16 color-black">
            {{ model.studentSie }}
          </span>
        </div>
        <div class="col-md-2  col-sm-12 mt-3 mt-md-0">
          <span class="color-gray-6 d-block font-14">
            Edad:
          </span>
          <span class="font-16 color-black">
            {{ model.studentAge }}
          </span>
        </div>
        <div class="col-md-2 col-sm-12 mt-3 mt-md-0">
          <span class="color-gray-6 d-block font-14">
            Número de Consulta:
          </span>
          <span class="font-16 color-black">
            {{ model.tapRequestNumber }}
          </span>
        </div>
        <div class="col-md-2 col-sm-12 mt-3 mt-md-0">
          <span class="color-gray-6 d-block font-14">
            SSN:
          </span>
          <span class="font-16 color-black">
            <div class="d-flex">
              <div class="mr-2">
                {{ formatSsn(model.ssn) }}
              </div>
              <i
                aria-hidden="true"
                class="mt-1 cursor-pointer"
                :class="{
                  'fal fa-eye': showSSN,
                  'fal fa-eye-slash': !showSSN,
                }"
                @click="showSSN = !showSSN"
              />
            </div>
          </span>
        </div>
        <div class="col-md-2 col-sm-12 mt-3 mt-md-0">
          <span class="color-gray-6 d-block font-14">
            Estatus:
          </span>
          <span class="font-16 color-black">
            {{ model.statusName }}
          </span>
        </div>
      </div>

      <div class="ml-2 mr-3 mt-4 pb-2 border-bottom" />

      <div
        v-if="isDirectPayment"
        class="col-12 mt-4 d-flex justify-content-end"
      >
        <action-button
          i="fas fa-times-circle"
          text="Cerrar"
          variant="outline-danger  m-md-2 px-4"
          @click="onCancel"
        />
        <action-button
          i="fa fa-arrow-alt-circle-right"
          text="Continuar"
          variant="success m-md-2 px-4"
          @click="onContinue"
        />
      </div>

      <validation-observer v-else ref="ssnRef">
        <div class="row pl-2 py-4">
          <div class="col-md-3 col-sm-12 mt-3 mt-md-0">
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El número de seguro social es requerido.',
                ssn: 'El número de seguro social no es válido.',
              }"
              rules="required|ssn"
            >
              <custom-input
                v-model="ssnNumber"
                :errors="errors[0]"
                label="Número de Seguro Social:"
                label-class="font-14"
                mask-type="Personalssn"
                maxlength="11"
                placeholder="xxx-xx-xxxx"
              />
              <error
                v-if="errors[0]"
                :message="errors[0]"
                variant="no-border mt-1"
              />
            </validation-provider>
          </div>
          <div
            class="col-md-8 col-sm-12 mt-4 pr-4 d-flex align-items-start justify-content-end"
          >
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger m-md-2 px-4"
              @click="onCancel"
            />
            <action-button
              i="fas fa-arrow-alt-circle-right"
              text="Continuar"
              variant="success m-md-2 px-4"
              @click="onContinue"
            />
            <div v-if="sifdeRegistryDocument" class="ml-2 mt-3">
              <a class="color-green" href="#" @click.prevent="downloadFile()">
                <i class="fas fa-file-download " />
                Descargar formulario de registro de SIFDE
              </a>
            </div>
          </div>

          <div class="col-12">
            <custom-error
              class="mr-3"
              is-alert-mode
              message="
              Para comenzar con el proceso de solicitud de reembolso, es importante que se encuentre registrado en el Sistema de Información Financiera del Departamento de Educación (SIFDE).
              "
            />
          </div>
        </div>
      </validation-observer>
    </div>
  </custom-callout>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import CustomCallout from 'custom-callout';
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import Error from 'custom-error';
import ActionButton from 'ActionButton';
import CustomError from 'custom-error';

import storeMixin from '@/shared/mixins/storeGenerator';
import alertMixin from '@/mixins/alert.mixin.js';
import {
  searchTaprequest as _searchTaprequest,
  getSIFDERegistrationDocument,
} from '@/modules/reinbursement/api.js';
import _generalApi from '@/modules/app/api.js';
import determinationTypes from '@/utils/constants/determinationTypes';
import disbursementRequestType from '@/utils/constants/disbursementRequestType';

extend('startsLikeTapRequestNumber', {
  validate: (value) => {
    if (!value || value == undefined) return false;
    let regex = /^([aA-zZ]{2,3})-([\d]{4})-([\d]{2})-([\d]{6})/g;

    return value.search(regex) !== -1;
  },
});

export default {
  name: 'RequestReinbursement',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomCallout,
    IconView,
    CustomInput,
    Error,
    ActionButton,
    CustomError,
  },
  mixins: [storeMixin, alertMixin],
  props: {
    requestType: {
      type: Number,
      required: true,
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    model: {
      tapRequestId: null,
      tapRequestNumber: null,
      academicYearId: null,
      studentSie: null,
      studentName: null,
    },
    sifdeRegistryDocument: null,
    showRequest: false,
    tapRequestNumber: null,
    ssnNumber: null,
    showSSN: false,
  }),
  computed: {
    startWithLetters() {
      const regex = /^[a-zA-Z].*/;
      return this.tapRequestNumber
        ? this.tapRequestNumber.match(regex)?.length > 0
        : false;
    },
    isDirectPayment() {
      return this.requestType === disbursementRequestType.DirectPayment;
    },
    formatSsn() {
      return (value) => {
        const lastDigits = value.substr(-4);
        return !this.showSSN ? `XXX-XX-${lastDigits}` : value;
      };
    },
  },
  async mounted() {
    await getSIFDERegistrationDocument().then(
      (res) => (this.sifdeRegistryDocument = res.data)
    );
  },
  methods: {
    async handlerSearch() {
      const isValid = await this.$refs.reinbursementRef.validate();
      if (!isValid) return;

      try {
        const { data } = await _searchTaprequest({
          number: this.tapRequestNumber,
          academicYearId: this.filter.academicYear.id,
          determinationType: this.isDirectPayment
            ? determinationTypes.DirectPayment
            : determinationTypes.Refund,
          schoolId: this.filter.school?.id,
        });
        this.model = data;
        this.showRequest = true;
      } catch (error) {
        this.ShowToast(
          '',
          error.response?.data?.message ??
            error.message ??
            'Ha ocurrido un error inesperado.',
          'error'
        );
      }
    },
    async onContinue() {
      const isValid = await this.$refs?.ssnRef?.validate();
      if (!isValid && !this.isDirectPayment) {
        return;
      }

      this.$router.push({
        name: 'NewReimbursement',
        params: {
          academicYearId: this.filter.academicYear.id,
          tapRequestId: this.model.tapRequestId,
          institutionId: this.filter.school?.id,
          ssn: this.ssnNumber ?? 0,
          requestTypeId: this.requestType,
          tapRequestNumber: this.tapRequestNumber,
        },
      });
    },
    onCancel() {
      this.model = {
        tapRequestId: null,
        tapRequestNumber: null,
        academicYearId: null,
        studentSie: null,
        studentName: null,
      };

      this.showRequest = false;
      this.tapRequestNumber = null;
      this.ssnNumber = null;

      this.$emit('on-cancel');
    },
    downloadFile() {
      if (this.sifdeRegistryDocument?.content) {
        _generalApi.ConvertToBlob(this.sifdeRegistryDocument);
      }
    },
  },
};
</script>

<style scoped>
.request-reinbursement-custom-callout {
  border-left: 4px solid #b5c3bc;
}
</style>
